<template>
  <el-dialog
    class="pass"
    title="Password"
    :visible.sync="visible"
    width="500px"
    :before-close="handleClose"
  >
    <el-form
      :model="passData"
      label-width="140px"
      :rules="rules"
      ref="settingForm"
    >
      <el-form-item prop="oldPassword" label="Original password">
        <el-input v-model="passData.oldPassword" type="password"></el-input>
      </el-form-item>
      <el-form-item prop="newPassword" label="New password">
        <el-input v-model="passData.newPassword" type="password"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()">Cancel</el-button>
      <el-button type="primary" @click="handleSubmit()">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "pass",
  data() {
    return {
      passData: {
        oldPassword: "",
        newPassword: "",
      },
      rules: {
        oldPassword: {
          required: true,
          pattern: /^[a-zA-Z0-9*#@_.%]+$/,
          message: "Please enter the original password",
        },
        newPassword: {
          required: true,
          pattern: /^[a-zA-Z0-9*#@_.%]+$/,
          message: "Please enter your new password",
        },
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleSubmit() {
      if (!this.passData.oldPassword || !this.passData.newPassword) {
        this.$message.error("Please enter both original and new password");
        return;
      }
      if (this.passData.oldPassword === this.passData.newPassword) {
        this.$message.error(
          "New password cannot be the same as original password",
        );
        return;
      }
      if (
        this.passData.newPassword.length < 6 ||
        this.passData.newPassword.length > 20
      ) {
        this.$message.error(
          "New password must be at least 6 characters and at most 20 characters",
        );
        return;
      }
      const rulesss = /^[a-zA-Z0-9*#@_.%]+$/;
      if (
        !rulesss.test(this.passData.newPassword) ||
        !rulesss.test(this.passData.oldPassword)
      ) {
        this.$message.error("Password format is wrong");
        return;
      }

      this.$http({
        url: `/user/change/password`,
        method: "put",
        data: this.passData,
      }).then(() => {
        this.$message.success("Password changed successfully");
        this.$emit("close");
        this.$wsApi.closeWebSocket();
        sessionStorage.removeItem("token");
        location.href = "/";
      });
    },
  },
};
</script>

<style scoped></style>
